var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-industry"},[_c('v-chart',{attrs:{"options":_vm.pie,"id":"chartPie","auto-resize":""}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNodata),expression:"isNodata"}],staticClass:"no-chart-data",staticStyle:{"color":"#D3D3D3","font-size":"20px"}},[_vm._v("Temporarily no data")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }